import UsersApi from './usersApi';

const host = process.env.REACT_APP_API_HOST;

export interface AppApi {
  users: UsersApi;
}

const Api: AppApi = {
  users: new UsersApi(host),
};

export default Api;



// WEBPACK FOOTER //
// ./src/api/api.js